<div class="toggle-container">
    @let firstMatchingTask = getFirstMatchingTask();
    <div class="d-flex gap-2">
        @for (filter of queryLinks(); track $index) {
            @if (filter) {
                <a [href]="filter.url" [matTooltipShowDelay]="0" [matTooltip]="filter.name" class="azure-query" target="_blank">
                    <i class="fas {{filter.icon}}"></i>
                </a>
            }
        }
    </div>
    <div class="task-search-container">
        <input
            #taskSearch
            (input)="taskSearchTerm.set(taskSearch.value)"
            (keydown.enter)="onTaskSearch(taskSearch.value)"
            (keydown.escape)="taskSearchTerm.set(''); taskSearch.value=''"
            class="form-control"
            placeholder="Zoek naar opdracht"
            type="text">
    </div>
    <label>
        <input (change)="showColleagues.set(!showColleagues())" [checked]="showColleagues()" type="checkbox">
        Toon collega's
    </label>
    <label>
        <input (change)="saveChangedDisplay(!showChanged())" [checked]="showChanged()" type="checkbox">
        Toon gewijzigd
    </label>
</div>
<div class="container-fluid mt-3">
    <div class="users-container">
        @for (user of (showColleagues() ? users() : (users() | filter : LocalStorage.user?.id : 'id')); track user.id) {
            @if (userHasResults(user.id)) {
                <div class="user">
                    <h4>{{user.name}}</h4>
                    <table class="table table-bordered table-sm text-end">
                        <tbody>
                            @for (week of weekList(); track week) {
                                <tr>
                                    <td>{{week}}</td>
                                    @for (isoDay of [2, 3, 4, 5, 6, 7, 1]; track isoDay) {
                                        @let absent = absentInfo(user.id, week, isoDay);
                                        @let monday = weekStringToMonday(week);
                                        @let dayDate = monday.getTime() + (isoDay === 1 ? 6 : isoDay - 2) * 24 * 60 * 60 * 1000;
                                        @let isToday = (dayDate | date:'yyyy-MM-dd') === (today | date:'yyyy-MM-dd');
                                        <td [class.absent]="absent.absent && !absent.color"
                                            [class.fw-bold]="isToday"
                                            [matTooltip]="formatAbsentTooltip(absent)"
                                            [matTooltipShowDelay]="500"
                                            [style.background]="absent.color | absentGradient : absent.startMinutes : absent.endMinutes">
                                            {{weeklyHours[user.id]?.[week]?.[isoDay] ? utils.decimalTime(weeklyHours[user.id][week][isoDay]) : ''}}
                                            <br>
                                            <small>{{dayDate | date:'EEE d MMM'}}</small>
                                        </td>
                                    }
                                    <td width="80" class="txtbold">{{weeklyHours[user.id]?.[week]?.['total'] ? utils.decimalTime(weeklyHours[user.id][week]['total']) : ''}}</td>
                                </tr>
                            }
                        </tbody>
                    </table>

                    @if (userTasks()[user.id]?.length) {
                        <b>Open taken</b>
                        <table class="table table-bordered table-sm mt-1">
                            <thead class="text-nowrap">
                                <tr>
                                    <th style="width:30px"></th>
                                    <th>ID</th>
                                    <th>Titel</th>
                                    @if (showChanged()) {
                                        <th>Changed</th>
                                    }
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody (cdkDropListDropped)="dropTask($event, user.id)" cdkDropList>
                                @for (task of userTasks()[user.id]; track task.id) {
                                    @if (taskMatchesSearch(task)) {
                                        <tr
                                            (click)="updateLastClickedTask(task)"
                                            (contextmenu)="openContextMenu($event, task)"
                                            [cdkDragDisabled]="!isDraggableTask(task)"
                                            [class.critical-bug]="isCriticalBug(task)"
                                            [class.first-search-result]="firstMatchingTask?.id === task.id"
                                            [class.last-selected-task]="lastSelectedTask() === task.id"
                                            [class.priority-task]="!isDraggableTask(task)"
                                            cdkDrag>
                                            <td
                                                [class.bug-handle]="task.workItemType === 'Bug'"
                                                [class.disabled]="!isDraggableTask(task)"
                                                [class.feature-handle]="task.workItemType === 'Feature'"
                                                [class.story-handle]="task.workItemType === 'User Story'"
                                                [class.task-handle]="task.workItemType === 'Task'"
                                                cdkDragHandle
                                                class="drag-handle">
                                                <span class="drag-icon">{{isDraggableTask(task) ? '☰' : '!!'}}</span>
                                            </td>
                                            <td [class.py-0]="task.parent_workItemType === 'User Story'" class="text-center small-td">
                                                @if (task.parent_workItemType === 'User Story') {
                                                    <div class="d-flex flex-column">
                                                        {{task.parent_id}}
                                                        <small>{{task.id}}</small>
                                                    </div>
                                                } @else {
                                                    {{task.id}}
                                                }
                                            </td>
                                            <td>
                                                <div class="title">
                                                    <small>
                                                        {{task.project | projectShortName}}
                                                        @if (task.grandparent_id) {
                                                            &raquo;
                                                            <a
                                                                [href]="'https://dev.azure.com/codalt/' + task.project + '/_workitems/edit/' + task.grandparent_id"
                                                                [title]="task.grandparent_title"
                                                                target="_blank">
                                                                {{task.grandparent_title | slice : 0 : 15}}
                                                            </a>
                                                        }
                                                        @if (task.parent_id) {
                                                            &raquo;
                                                            <a
                                                                [href]="'https://dev.azure.com/codalt/' + task.project + '/_workitems/edit/' + task.parent_id"
                                                                [title]="task.parent_title"
                                                                target="_blank">
                                                                {{task.parent_title | slice : 0 : 15}}
                                                            </a>
                                                        }
                                                    </small>
                                                    &raquo;
                                                    <a [href]="'https://dev.azure.com/codalt/' + task.project + '/_workitems/edit/' + task.id" [title]="task.title" target="_blank">
                                                        {{task.title}}
                                                    </a>
                                                </div>
                                            </td>
                                            @if (showChanged()) {
                                                <td class="text-end py-0 small-td">
                                                    <div class="d-flex flex-column">
                                                        {{task.changed_by | changedByNameSplitting}}
                                                        <small class="d-flex justify-content-between w-100">
                                                            <span>
                                                                @if (task.relatedPRs?.length > 0) {
                                                                    <i class="fa-solid fa-code-pull-request"></i>
                                                                    {{task.relatedPRs?.length}}
                                                                }
                                                            </span>
                                                            <span>
                                                                {{task.changed_date | codaltDate:'EEE d MMM':true}}
                                                            </span>
                                                        </small>
                                                    </div>
                                                </td>
                                            }
                                            <td [class]="(task.state | sortedTaskBackgroundColor)" class="text-end">{{task.state}}</td>
                                        </tr>
                                    }
                                }
                            </tbody>
                        </table>
                    }

                    @if (userPRs()[user.id]?.length) {
                        @for (project of userPRs()[user.id]; track project.project) {
                            <b>{{project.project}}</b>
                            @if (project.error) {
                                <div class="text-danger">Fout: {{project.error}}</div>
                            }
                            @if (project.prs?.length) {
                                <table class="table table-bordered table-sm">
                                    <tbody>
                                        @for (pr of project.prs; track pr.pullRequestId) {
                                            @if (prMatchesSearch(pr, project.project)) {
                                                <tr [class.draft]="pr.isDraft" (contextmenu)="openContextMenuForPR($event, pr, project.project)">
                                                    <td style="width:125px">
                                                        @if (pr.isDraft) {
                                                            DRAFT:
                                                        }
                                                        <a
                                                            [href]="'https://dev.azure.com/codalt/' + project.project + '/_git/' + pr.repository.name + '/pullrequest/' + pr.pullRequestId+'?_a=files'"
                                                            target="_blank">
                                                            !{{pr.pullRequestId}}
                                                        </a><br>
                                                        {{pr.creationDate | date:'EEE d MMM HH:mm'}}
                                                    </td>
                                                    <td>{{pr.title}}</td>
                                                    <td style="width:100px">
                                                        {{pr.status}}
                                                        <div class="reviewers mt-1">
                                                            @for (reviewer of pr.reviewers; track reviewer.id) {
                                                                <img
                                                                    [alt]="reviewer.displayName"
                                                                    [class.reviewer-accepted]="reviewer.vote === 10 || reviewer.vote === 5"
                                                                    [class.reviewer-rejected]="reviewer.vote === -5 || reviewer.vote === -10"
                                                                    [class.reviewer-waiting]="reviewer.vote === 0"
                                                                    [title]="reviewer.displayName + ' ' + (reviewer.vote === 10 || reviewer.vote === 5 ? 'heeft goedgekeurd' : (reviewer.vote === 0 ? 'heeft nog niet gereviewd' : 'heeft afgekeurd')) + ' PR op ' + (pr.creationDate | date:'EEE d MMM HH:mm')"
                                                                    class="reviewer-avatar"
                                                                    height="24"
                                                                    ngSrc="{{reviewer._links.avatar.href}}"
                                                                    width="24"/>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    </tbody>
                                </table>
                            }
                        }
                    } @else {
                        <div class="text-muted">
                            Geen open pull requests
                            <br><br><br>
                        </div>
                    }
                </div>
            }
        }
        @if (!showColleagues() && getFirstMatchingTask()) {
            <div (click)="onTaskSearch(taskSearch.value)" class="user mt-3 d-flex align-items-end curpoint overflow-hidden">
                <h4>Jouw zoekterm heeft resultaten, maar deze staan onder andere collega's</h4>
            </div>
        } @else if (this.taskSearchTerm().trim() && !getFirstMatchingTask()) {
            <div (click)="onTaskSearch(taskSearch.value)" class="user mt-3 d-flex align-items-end curpoint overflow-hidden">
                <h4>Jouw zoekterm heeft geen resultaten, druk op enter om in azure devops te kijken of het bestaat</h4>
                <button color="primary" mat-icon-button>
                    <mat-icon class="remove-overflow" fontIcon="fa-arrow-up-right-from-square" fontSet="fas"></mat-icon>
                </button>
            </div>
        }
    </div>
</div>

<ng-template #taskContextMenu>
    <div class="context-menu-panel">
        @for (platform of contextMenuTask().platform; track platform.id) {
            <div class="context-menu-header"><b>{{platform.name}}</b></div>
            <div>
                @if (platform.prod_url) {
                    <a [href]="platform.prod_url | urlCombining : contextMenuTask().azure_task.url" target="_blank">
                        <div class="context-menu-cell">
                            <span>Prod: </span>
                            <p>{{(platform.prod_url | urlCombining : contextMenuTask().azure_task.url) | urlPrefixStripping}}</p>
                        </div>
                    </a>
                }
                @if (platform.acc_url) {
                    <a [href]="platform.acc_url | urlCombining : contextMenuTask().azure_task.url" target="_blank">
                        <div class="context-menu-cell">
                            <span>Acc: </span>
                            <p>{{(platform.acc_url| urlCombining : contextMenuTask().azure_task.url) | urlPrefixStripping}}</p>
                        </div>
                    </a>
                }
                @if (platform.test_url) {
                    <a [href]="platform.test_url | urlCombining : contextMenuTask().azure_task.url" target="_blank">
                        <div class="context-menu-cell">
                            <span>Test: </span>
                            <p>{{(platform.test_url | urlCombining : contextMenuTask().azure_task.url) | urlPrefixStripping}}</p>
                        </div>
                    </a>
                }
                @if (platform.local_url) {
                    <a [href]="platform.local_url | urlCombining : contextMenuTask().azure_task.url" target="_blank">
                        <div class="context-menu-cell">
                            <span>Local: </span>
                            <p>{{(platform.local_url | urlCombining : contextMenuTask().azure_task.url) | urlPrefixStripping}}</p>
                        </div>
                    </a>
                }
            </div>
        } @empty {
            <div class="context-menu-header text-muted">Er zijn geen URLs gevonden</div>
        }
        @if (contextMenuTask().relatedPRs?.length) {
            <div class="context-menu-header"><b>Pull Requests</b></div>
            @for (item of contextMenuTask().relatedPRs; track item.pr.pullRequestId) {
                <a [href]="'https://dev.azure.com/codalt/' + item.project + '/_git/' + item.pr.repository.name + '/pullrequest/' + item.pr.pullRequestId + '?_a=files'"
                   target="_blank">
                    <div class="context-menu-cell">
                        <span>!{{item.pr.pullRequestId}}</span>
                        <p>
                            {{item.pr.title}}
                            <br>
                            <small>{{item.pr.creationDate | codaltDate:'EEE d MMM':true}} - {{item.pr.createdBy?.displayName}}</small>
                        </p>
                    </div>
                </a>
                @if (item.pr.repository.name === 'Planning') {
                    <a href="https://pr-{{item.pr.pullRequestId}}-dvds.planning.codalt.com/" target="_blank">
                        <div class="context-menu-cell">
                            <span>!{{item.pr.pullRequestId}}</span>
                            <p>test DvdS</p>
                        </div>
                    </a>
                    <a href="https://pr-{{item.pr.pullRequestId}}-trackline.planning.codalt.com/" target="_blank">
                        <div class="context-menu-cell">
                            <span>!{{item.pr.pullRequestId}}</span>
                            <p>test Track Line</p>
                        </div>
                    </a>
                }
            }
        }
    </div>
</ng-template>
